import React, { useEffect } from "react";
import PageCarousel from "../components/PageCarousel";

function Challenges() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const challenges = [
    {
      title:
        "Automated Detection of Glacial Lakes from Multi-Temporal Satellite Imagery",
      organisers:
        "Dr. S. Vidhusha, Dr. K. B. Sundhara Kumar, Dr. K. Uthradevi (Shiv Nadar University Chennai)",
      abstract:
        "Rapid glacier retreat driven by climate change has resulted in the widespread formation and expansion of glacial lakes in high-altitude mountain regions across the world. These lakes, particularly those dammed by loose moraines or remnant ice, pose a significant hazard in the form of Glacial Lake Outburst Floods (GLOFs). Accurate identification of glacial lakes is a fundamental prerequisite for reliable GLOF hazard assessment and improved flood prediction. In this challenge, participants will work with Sentinel-2 multispectral imagery available through the IEEE DataPort dataset to design a computationally efficient and accurate framework for glacial lake detection in complex mountainous terrain. The task encourages the integration of image processing techniques, spectral indices, terrain analysis, and deep learning models to effectively distinguish glacial lakes from snow, ice, debris-covered surfaces, and terrain shadows, while minimizing false alarms. Emphasis will be placed on developing a robust and well-validated model with clear performance evaluation and uncertainty assessment to ensure real-world applicability in GLOF risk mapping and early warning systems. By connecting reliable lake detection to flood hazard assessment and climate adaptation strategies, this challenge aligns with SDG 9 (Industry, Innovation and Infrastructure), SDG 11 (Sustainable Cities and Communities), and SDG 13 (Climate Action), promoting data-driven solutions for environmental resilience and public safety.",
      awards:
        "First Prize – ₹15,000 | 1st Runner Up – ₹10,000 | 2nd Runner Up – ₹5,000",
      webpage: "https://glof.snuchennai.edu.in/",
      pdf: "/Challenge_1.pdf",
      registration:
        "https://docs.google.com/forms/d/1v4jBIMp27TMPKjHrwRhxfq3-OC80B1Ze-tMfYboV5ao/edit",

      winners: [
        {
          position: "🥇 1st Winner",
          names: "Iyyappan R, Visves T R, Senthilarasi M",
          institution: "Thiagarajar College of Engineering, Madurai",
        },
        {
          position: "🥈 2nd Winner",
          names: "Sharron Teena J, Hrishikesh D",
          institution:
            "Madras Institute of Technology, Anna University Chennai",
        },
        {
          position: "🥉 3rd Winner",
          names: "Kiruthika S., Joshan Athanesious, Linga Adithya",
          institution: "Vellore Institute of Technology, Chennai",
        },
      ],
    },

    {
      title:
        "AutoAnn-Indic: Human-Effort Efficient Automated Annotation for Indic Manuscripts and Ram Charit Manas",
      organisers:
        "Dr. Indra Deep Mastan, Dr. Aprajita Khan, Mr. Satyendra Yadav (IIT (BHU) Varanasi), Dr. Anukriti Bansal (The LNMIIT Jaipur)",
      abstract:
        "The AutoAnn-Indic competition is a way of generating automated annotations for Indian heritage manuscripts. The overall objective is to generate high-quality pre-annotations that will allow human annotators to work quickly and efficiently. The dataset contains multiple Indic manuscripts, with a specific focus on the subset from Ramcharit Manas. Competitors will submit their predictions in standard submission formats (i.e., PAGE-XML or JSON-based) for the layout auto-annotation (text regions, marginalia, illustrations, page/frame, damage) and for the text lines/bases of text extraction. The evaluations of these submissions will be based on evaluating the quality of the auto-annotations using a hidden test set and the efficiency of annotating them by measuring the median time of correction per page under a fixed tool type and protocol to gauge the human effort involved. The AutoAnn-Indic Challenge will help generate a scalable ground truth and create more robust OCR/HTR and document-understanding pipelines for Indian cultural heritage.",
      awards: null,
      webpage: "https://ncvpripg-challenge.vercel.app/",
      pdf: "/Challenge_2.pdf",
      registration:
        "https://docs.google.com/forms/d/e/1FAIpQLSc5GgGStpmC8UXh6FThvDAs89V7Objow-NAHAd__nJIcYq-TQ/viewform?usp=dialog",

      winners: [
        {
          position: "🥇 1st Winner",
          names:
            "Dakshan Karthic S., S. Medwin Manuel S., R. S. Pranav Kumar, E. Vishagan",
          institution:
            "Velammal College of Engineering and Technology, Madurai, Tamil Nadu",
        },
      ],
    },

    {
      title:
        "Persistent Scene Change Detection and Localization in Fixed-Camera Surveillance Videos (PSCDL 2026)",
      organisers:
        "Dr. Shikha Gupta, Shivam Nigam, Rizwan, Abhijith P Mahadevan (Vehant Technologies Private Limited)",
      abstract:
        "The Persistent Scene Change Detection and Localization (PSCDL 2026) challenge addresses the problem of identifying and localizing long-duration scene modifications in fixed-camera urban surveillance videos. While existing video analytics systems primarily focus on short-term events such as motion or intrusion, real-world urban management often requires detecting persistent changes such as unattended objects, debris accumulation, graffiti, illegal dumping, or temporary encroachments that remain over extended periods. These sustained modifications, though not immediately hazardous, can impact public safety, accessibility, and civic order if left unaddressed. Detecting them reliably is challenging due to illumination variations, weather conditions, dynamic backgrounds, and the need for robust temporal reasoning to distinguish transient motion from persistent presence. In PSCDL 2026, participants are provided with video clips containing an initial clean baseline segment followed by the introduction of a persistent change, and are tasked with both detecting the occurrence of the modification and generating a pixel-level binary mask for accurate localization. Submissions will be evaluated using pixel-level segmentation metrics such as Precision, Recall, and F1-score, with the goal of establishing a benchmark that advances practical, deployment-ready solutions for long-term scene monitoring in urban environments.",
      awards: "First Prize – ₹25,000 | 1st Runner Up – ₹20,000",
      webpage:
        "https://www.vehant.com/the-persistent-scene-change-detection-and-localization-pscdl-2026/",
      pdf: "/Challenge_3.pdf",
      registration:
        "https://docs.google.com/forms/d/e/1FAIpQLSdAFJe5OZyIiVtg6S2fQXOm1mh_vlqIg9lGm9IfJJVz3o2AnA/viewform?usp=publish-editor",

      winners: [
        {
          position: "🥇 1st Winner",
          names: "Joseph S Mathew, Jiyaro Joseph",
          institution: "Govt. Model Engineering College, Thrikkakara",
        },
        {
          position: "🥈 2nd Winner",
          names: "Pokuri Siva Sai Krishna",
          institution: "MVGR College of Engineering",
        },
      ],
    },
  ];

  return (
    <div className="page-container">
      <PageCarousel />

      <section className="section-padding">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="section-title-header text-center mb-5">
                <h1 className="section-title">Challenges</h1>
                <p className="text-muted">
                  Explore our exciting research challenges and win attractive
                  prizes.
                </p>
              </div>

              <div className="row justify-content-center">
                <div className="col-lg-10 col-md-12">
                  {challenges.map((challenge, index) => (
                    <div
                      key={index}
                      className="mb-5 p-4 bg-white"
                      style={{
                        borderRadius: "12px",
                        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                        borderLeft: "5px solid #70b60a",
                      }}
                    >
                      <h4 className="mb-3" style={{ fontWeight: 600 }}>
                        {challenge.title}
                      </h4>

                      <p>
                        <strong>Organisers:</strong> {challenge.organisers}
                      </p>

                      <p>
                        <strong>Abstract:</strong> {challenge.abstract}
                      </p>

                      {challenge.awards && (
                        <div
                          className="mb-3 p-2"
                          style={{
                            background: "#f8fff2",
                            borderRadius: "6px",
                            fontWeight: 500,
                          }}
                        >
                          🏆 <strong>Awards Proposed:</strong>{" "}
                          {challenge.awards}
                        </div>
                      )}

                      {/* Winners */}
                      {challenge.winners && (
                        <div
                          className="mb-4 p-3"
                          style={{
                            background: "#fff9e6",
                            borderRadius: "8px",
                            border: "1px solid #f0d98a",
                          }}
                        >
                          <h5 className="mb-3">
                            🏅 <strong>Challenge Winners</strong>
                          </h5>

                          {challenge.winners.map((winner, i) => (
                            <div key={i} className="mb-3">
                              <strong>{winner.position}</strong>
                              <br />
                              {winner.names}
                              <br />
                              <span className="text-muted">
                                {winner.institution}
                              </span>
                            </div>
                          ))}
                        </div>
                      )}

                      <div className="d-flex flex-wrap gap-2">
                        <a
                          href={challenge.webpage}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-primary"
                        >
                          Challenge Webpage
                        </a>

                        <a
                          href={challenge.pdf}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-success"
                        >
                          For More Details
                        </a>

                        
                      </div>

                      {index < challenges.length - 1 && (
                        <hr className="my-4" />
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Challenges;